import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DignifiedCareAtHome() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="27252" id="navigate-your-diagnosis-with-confidence" ref={sectionRef} className="relative w-full overflow-hidden bg-background py-12 lg:py-16 xl:py-20">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-lg bg-accent/50 blur-3xl opacity-40" />
        <div className="absolute top-[40%] right-[0%] h-[500px] w-[500px] rounded-lg bg-muted/30 blur-3xl opacity-30" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16 items-center">
          <div className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <Badge variant="outline" className="w-fit border-chart-2/20 text-chart-2 bg-chart-2/5 px-3 py-1 text-sm font-medium rounded-lg">
                Empathetic Prostate Cancer Support
              </Badge>

              <h1 className="w-full font-serif text-5xl font-bold leading-[1.1] tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-7xl"><span className="!text-6xl">Understand Your Diagnosis.</span> <br /><span className="inline-block pr-2 text-transparent bg-clip-text bg-gradient-to-r from-chart-3 to-chart-2 italic" contenteditable="false" style={{}}><span className="!text-5xl">Make an Educated Decision.</span></span></h1>

              <p className="max-w-2xl text-lg text-muted-foreground md:text-xl leading-relaxed">My name is Paul. I'm an epidemiologist with over 20 years of experience studying prostate cancer, men's health, and benign prostate conditions. I help you interpret your results, evaluate your options, and move forward with clarity and confidence at every step of your journey.<div data-ast-id="f:/src/pages/Home/sections/DignifiedCareAtHome.tsx|sig:54yq9b" data-ast-start="2343" data-ast-end="2679"><br />Whether you're local to Denver or anywhere in the world, I offer both in-person and virtual consultations to help bridge the gap between complex medical information and the decisions that matter most to you.</div></p>

              

              
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-12 px-8 text-base bg-chart-3 hover:bg-chart-3/90 text-white shadow-lg shadow-chart-3/20 transition-transform hover:-translate-y-0.5">
                <Link to="/NavigationServicesPage">
                  Get Support
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-12 px-8 text-base border-chart-3/20 text-chart-3 hover:bg-chart-3/5 hover:text-chart-3 transition-transform hover:-translate-y-0.5">
                <Link to="/NavigationServicesPage">See How It Works</Link>
              </Button>
            </div>
          </div>

          <div className={`relative mx-auto w-full max-w-[500px] lg:max-w-none transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="absolute top-1/2 left-1/2 -z-10 h-[120%] w-[120%] -translate-x-1/2 -translate-y-1/2">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="h-full w-full opacity-20">
                <path fill="var(--chart-2)" d="M44.7,-76.4C58.9,-69.2,71.8,-59.1,81.6,-46.6C91.4,-34.1,98.1,-19.2,95.8,-5.3C93.5,8.6,82.2,21.5,70.6,32.2C59,42.9,47.1,51.4,34.8,58.6C22.5,65.8,9.8,71.7,-1.8,74.8C-13.4,77.9,-23.9,78.2,-34.7,73.3C-45.5,68.4,-56.6,58.3,-65.6,46.6C-74.6,34.9,-81.5,21.6,-83.1,7.6C-84.7,-6.4,-81,-21.1,-72.7,-33.3C-64.4,-45.5,-51.5,-55.2,-38.4,-62.9C-25.3,-70.6,-12,-76.3,2.1,-79.9C16.2,-83.5,30.5,-83.6,44.7,-76.4Z" transform="translate(100 100) scale(1.1)" />
              </svg>
            </div>

            <div className="relative aspect-[3/4] w-1/2 mx-auto overflow-hidden rounded-lg shadow-2xl ring-1 ring-border/50">
              <img src="https://myprostatepath.com/wp-content/uploads/2026/07/Paul.jpg" alt="Paul, the prostate cancer navigator" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none" />
            </div>

            

            <div className="absolute -top-6 -right-6 -z-10 hidden lg:block">
              <div className="grid grid-cols-3 gap-2">
                {[...Array(9)].map((_, i) => <div key={i} className="h-2 w-2 rounded-lg bg-chart-3/20" />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}